import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Volume2, VolumeX } from 'lucide-react';

export const AudioToggle = ({ enabled, onChange, testId }) => (
  <div className="flex items-center justify-between rounded-2xl bg-white/5 p-4">
    <div className="flex items-center gap-3">
      {enabled ? (
        <Volume2 size={20} className="text-[#38BDF8]" />
      ) : (
        <VolumeX size={20} className="text-[#CBD5E1]" />
      )}
      <span className="font-semibold text-white">Enable sounds</span>
    </div>
    <Switch
      checked={enabled}
      onCheckedChange={onChange}
      aria-label="Enable sounds"
      data-testid={testId || 'audio-toggle'}
    />
  </div>
);

export default AudioToggle;
